var _path, _path2, _path3, _rect, _path4, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _rect2, _rect3, _polygon10, _polygon11, _path5, _path6, _path7, _path8, _path9, _rect4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _polygon12, _polygon13;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgStorefront = function SvgStorefront(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 65 50.32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.08,38.21c0,.37.09.73.25,1.03-.15-.34-.23-.72-.24-1.12,0,.03,0,.06,0,.09Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m35.21,39.24c.06-.19.1-.39.11-.6,0-.09.02-.19.02-.28,0-.02,0-.05,0-.07,0,.08,0,.16-.01.25-.02.24-.06.47-.11.7Z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m35.33,28.16v9.72c0,.11.02.22.02.33,0,.03,0,.05,0,.08,0,.02,0,.05,0,.07,0,.09,0,.19-.02.28v.6h.02v3.89H10.78v-14.98h-6.33v22.17h33.5v-22.17h-2.62Z",
    fill: "#fdb73e"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.17,
    y: 28.16,
    width: 5.76,
    height: 22.17,
    fill: "#fdb73e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m56.79,16.61c0,2.24-1.82,4.06-4.06,4.06s-4.06-1.82-4.06-4.06c0,2.24-1.82,4.06-4.06,4.06s-4.06-1.82-4.06-4.06c0,2.24-1.82,4.06-4.06,4.06s-4.06-1.82-4.06-4.06c0,2.24-1.82,4.06-4.06,4.06h0c-2.24,0-4.06-1.82-4.06-4.06,0,2.24-1.82,4.06-4.06,4.06s-4.06-1.82-4.06-4.06c0,2.24-1.82,4.06-4.06,4.06s-4.06-1.82-4.06-4.06c0,2.11-1.61,3.84-3.66,4.04v7.51h6.33v-6.29h24.54v6.29h2.62v-6.29h16.22v6.29h5.76v-7.6c-1.8-.42-3.14-2.02-3.14-3.95Z",
    fill: "#d6842d"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "48.6 13.18 45.01 0 38.73 0 40.56 13.18 48.6 13.18",
    fill: "#f4abe0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "24.34 13.18 32.45 13.18 32.45 13.18 32.71 0 26.7 0 24.28 13.18 24.34 13.18",
    fill: "#f4abe0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "16.2 13.18 21.2 0 14.33 0 8.14 13.18 16.2 13.18",
    fill: "#f4abe0"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "56 0 50.51 0 56.72 13.18 56.79 13.18 59.93 13.18 64.9 13.18 64.9 13.19 65 13.19 56 0",
    fill: "#f4abe0"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "8.11 13.18 8.14 13.18 14.33 0 8.31 0 7.79 0 0 13.18 4.45 13.18 8.11 13.18",
    fill: "#f0592b"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "48.67 13.18 56.72 13.18 50.51 0 45.01 0 48.6 13.18 48.67 13.18",
    fill: "#f0592b"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "40.56 13.18 38.73 0 32.71 0 32.45 13.18 40.56 13.18",
    fill: "#f0592b"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "16.22 13.18 24.28 13.18 26.7 0 21.2 0 16.2 13.18 16.22 13.18",
    fill: "#f0592b"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "51.55 28.16 51.55 37.14 40.56 37.14 40.56 28.16 37.94 28.16 37.94 50.32 40.56 50.32 40.56 40.74 51.55 40.74 51.55 50.32 54.17 50.32 54.17 28.16 51.55 28.16",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.56,
    y: 28.16,
    width: 10.99,
    height: 8.99,
    fill: "#98d3cb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.56,
    y: 40.74,
    width: 10.99,
    height: 9.59,
    fill: "#98d3cb"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "40.56 24.86 51.55 24.86 51.55 28.16 54.17 28.16 54.17 26.36 54.17 21.87 37.94 21.87 37.94 26.36 37.94 28.16 40.56 28.16 40.56 24.86",
    fill: "#bcc3c8"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "13.61 24.86 32.35 24.86 32.35 28.16 35.33 28.16 35.33 21.87 10.78 21.87 10.78 28.16 13.61 28.16 13.61 24.86",
    fill: "#bcc3c8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m35.33,39.24v-.6c-.02.2-.06.4-.11.6h.11Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m11.34,39.24c-.16-.31-.25-.66-.25-1.03,0-.03,0-.06,0-.09,0-.03,0-.06,0-.09,0-1.41.94-2.54,2.1-2.54.15,0,.29.02.43.05v-7.38h-2.82v11.08h.55Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m32.35,34.03c1.66.65,2.84,2.12,2.98,3.85v-9.72h-2.98v5.88Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m20.63,36.88c.11-.13.25-.23.38-.34h-.45c.02.11.06.22.07.34Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m25.55,37.34c.06-.28.15-.54.26-.8h-.97c.28.22.52.49.71.8Z",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.56,
    y: 24.86,
    width: 10.99,
    height: 3.29,
    fill: "#1c9b8f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m14.58,36.14s.01-.04.02-.06c.46-1.44,1.59-2.46,2.93-2.46s2.47,1.02,2.93,2.46c.05.15.07.31.1.47h.45c.23-.19.48-.35.76-.47.36-.15.75-.23,1.15-.23s.8.08,1.15.23c.28.12.54.28.77.47h.97c.07-.16.14-.32.22-.47.83-1.43,2.47-2.41,4.36-2.41.69,0,1.35.13,1.95.37v-5.88H13.61v7.38c.34.09.66.28.92.54.02.02.04.04.05.06Z",
    fill: "#98d3cb"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m8.11,16.61v-3.43H0v3.43c0,2.24,1.82,4.06,4.06,4.06.13,0,.26,0,.39-.02,2.06-.2,3.66-1.93,3.66-4.04Z",
    fill: "#cd3147"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m24.28,13.18h-8.05v3.43c0,2.24,1.82,4.06,4.06,4.06s4.06-1.82,4.06-4.06v-3.43h-.06Z",
    fill: "#cd3147"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m32.45,13.18h0v3.43c0,2.24,1.82,4.06,4.06,4.06s4.06-1.82,4.06-4.06v-3.43h-8.11Z",
    fill: "#cd3147"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m48.67,16.61c0,2.24,1.82,4.06,4.06,4.06s4.06-1.82,4.06-4.06v-3.43h-8.11v3.43Z",
    fill: "#cd3147"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m16.2,13.18h-8.09v3.43c0,2.24,1.82,4.06,4.06,4.06s4.06-1.82,4.06-4.06v-3.43h-.02Z",
    fill: "#ef6ba0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m24.34,13.18v3.43c0,2.24,1.82,4.06,4.06,4.06h0c2.24,0,4.06-1.82,4.06-4.06v-3.43h-8.11Z",
    fill: "#ef6ba0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m48.6,13.18h-8.04v3.43c0,2.24,1.82,4.06,4.06,4.06s4.06-1.82,4.06-4.06v-3.43h-.07Z",
    fill: "#ef6ba0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m59.93,13.18h-3.14v3.43c0,1.92,1.34,3.53,3.14,3.95.29.07.6.11.92.11,2.24,0,4.06-1.82,4.06-4.06v-3.42h0s-4.97,0-4.97,0Z",
    fill: "#ef6ba0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m32.35,34.03c-.6-.24-1.26-.37-1.95-.37-1.89,0-3.53.98-4.36,2.41-.09.15-.16.31-.22.47-.11.26-.2.52-.26.8-.19-.31-.43-.57-.71-.8-.23-.19-.49-.35-.77-.47-.36-.15-.75-.23-1.15-.23s-.8.08-1.15.23c-.28.11-.53.28-.76.47-.13.11-.26.21-.38.34-.01-.12-.05-.22-.07-.34-.03-.16-.05-.32-.1-.47-.46-1.44-1.59-2.46-2.93-2.46s-2.47,1.02-2.93,2.46c0,.02-.01.04-.02.06-.02-.02-.03-.04-.05-.06-.26-.26-.57-.45-.92-.54-.14-.03-.28-.05-.43-.05-1.16,0-2.1,1.14-2.1,2.54,0,.03,0,.06,0,.09.01.41.09.79.24,1.12h23.88c.06-.23.1-.46.11-.7,0-.08.01-.16.01-.25,0-.03,0-.05,0-.08,0-.11,0-.22-.02-.33-.14-1.73-1.32-3.19-2.98-3.85Z",
    fill: "#84a82d"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.34 39.24 10.78 39.24 10.78 40.74 10.78 43.13 35.35 43.13 35.35 39.24 35.33 39.24 35.21 39.24 11.34 39.24",
    fill: "#d6842d"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "24.6 28.16 32.35 28.16 32.35 24.86 13.61 24.86 13.61 28.16 21.46 28.16 24.6 28.16",
    fill: "#1c9b8f"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStorefront, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/storefront.092977b1.svg";
export { ForwardRef as ReactComponent };